import React from "react";
import Header from "../layout/Header";
import Footer from "../layout/Footer";
import CourseSidebar from "../components/CourseSidebar";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import "../i18n"; // important to import
function FeaturedGoldCourseDetails() {
  const { t } = useTranslation("FeaturedGoldCourseDetails");
  return (
    <>
      <Header />
      <section>
        <div className="featured-main">
          <div className="container">
            <div className="breadcrumb-main">
              <nav aria-label="breadcrumb">
                <ol className="breadcrumb mb-3 mb-md-5">
                  <li className="breadcrumb-item">
                    <Link to="">{t("home")} </Link>
                  </li>
                  <li className="breadcrumb-item">
                    <Link to="">{t("technology")}</Link>
                  </li>
                  <li className="breadcrumb-item">
                    <Link to="">{t("minicourse")}</Link>
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    {t("fraudprevention")}
                  </li>
                </ol>
              </nav>
            </div>
            <div className="row justify-content-between align-items-center mb-4 mb-md-5 mb-lg-6">
              <div className="col-12 col-md-12 col-lg-6">
                <div className="d-flex align-items-center gap-3">
                  <span className="badge badge-black text-white rounded-2 fw-400 fs-7 mb-4">
                    {t("itsecurity")}
                  </span>
                  <span class="badge badge-light text-black rounded-2 fw-400 fs-7 mb-4">
                    {t("free")}
                  </span>
                </div>
                <h2 className="text-black fw-400">
                  {t("learningtoworkwithfigma")}
                </h2>
              </div>
              <div className="col-12 col-md-12 col-lg-6 mt-4">
                <div className="row justify-content-end">
                  <div className="col-lg-12 col-xl-8">
                    <div className="row justify-content-between align-items-center g-0 mb-2">
                      <p className="col-6 col-md-7 fw-500 text-black mb-0 fs-7 fs-sm-7">
                        {t("advancedachievers")}
                      </p>
                      <div className="col-6 col-md-5 d-flex align-items-center">
                        <ul className="rectangle rectangle2 d-flex align-items-center gap-2 gap-md-3 flex-wrap mb-0 p-0">
                          <li className="active" />
                          <li className="active" />
                          <li className="active" />
                          <li className="active" />
                        </ul>
                      </div>
                    </div>
                    <div className="row justify-content-between align-items-center g-0 mb-2">
                      <p className="col-6 col-md-7 fw-400 text-black mb-0 fs-7 fs-sm-7">
                        {t("promembership")}
                      </p>
                      <div className="col-6 col-md-5 d-flex align-items-center gap-2">
                        <img
                          src="featured-courses/diamond.jpg"
                          className="wh-20"
                          alt=""
                        />
                        <p className="mb-0 text-black fw-500 fs-7 fs-sm-7">
                          {t("premiumpass")}
                        </p>
                      </div>
                    </div>
                    <div className="row justify-content-end align-items-center g-0 mb-2">
                      <p className="col-6 col-md-7 fw-400 text-black mb-0 fs-7 fs-sm-7">
                        {t("duration")}
                      </p>
                      <div className="col-6 col-md-5 d-flex align-items-center gap-2">
                        <img
                          src="featured-courses/hourglass.png"
                          className="wh-20"
                          alt=""
                        />
                        <p className="mb-0 text-black fw-500 fs-7 fs-sm-7">
                          5 {t("hours")}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="row g-4 g-md-3 g-lg-4 g-xl-5">
              <div className="col-md-12 col-lg-8">
                <div>
                  <h4 className="text-black fw-500">{t("heading1")}</h4>
                  <p className="text-muted fw-400 mt-3 mb-4 mb-md-5">
                    {t("des1")}
                  </p>
                  <h4 className="text-black fw-500">{t("heading2")}</h4>
                  <p className="text-muted fw-400 mt-3 mb-5">{t("des2")}</p>
                  <h4 className="text-black fw-500">{t("heading3")}</h4>
                  <p className="text-muted fw-400 mt-3 mb-5">{t("des3")}</p>
                  <h4 className="text-black fw-500">{t("heading4")}</h4>
                  <p className="text-muted fw-400 mt-3 mb-5">{t("des4")}</p>
                  <h4 className="text-black fw-500">{t("heading5")}</h4>
                  <p className="text-muted fw-400 mt-3 mb-5">{t("des5")}</p>
                  <h4 className="text-black fw-500">{t("heading6")}</h4>
                  <p className="text-muted fw-400 mt-3 mb-0 mb-md-5">
                    {t("des6")}
                  </p>
                  <b className="text-muted pt-5 d-block fs-6">
                    {t("refrences")} :
                  </b>
                  <ul className="references-list references-list-2  mt-4">
                    <li>
                      - {t("uberdesign")}
                      <Link to="" className="text-muted">
                        [https://www.uber.design/](https://www.uber.design/).
                      </Link>
                      {t("retrievedOnAugust")} 16, 2023.
                    </li>
                    <li>
                      {t("impactOfAIOnWebDesign")}15, 2022,
                      <Link to="" className="text-muted">
                        https://www.webflow.com/survey
                      </Link>
                    </li>
                    <li>
                      - {t("dropbox")}
                      <Link to="" className="text-muted">
                        [https://www.dropbox.design/](https://www.dropbox.design/).
                      </Link>{" "}
                      {t("retrievedOnAugust")} 16, 2023.
                    </li>
                    <li>
                      - {t("microsoftline")}
                      <Link to="" className="text-muted">
                        [https://www.microsoft.com/design/](https://www.microsoft.com/design/)
                      </Link>
                      {t("retrievedOnAugust")}16, 2023.
                    </li>
                    <li>
                      - {t("figmablog")}
                      <Link to="" className="text-muted">
                        [https://www.figma.com/blog/](https://www.figma.com/blog/).
                      </Link>
                      {t("retrievedOnAugust")} 16, 2023.
                    </li>
                  </ul>
                  <p className="text-muted mt-5 fs-7">{t("note1")}</p>
                  <p className="text-muted mb-5 pt-3 pt-md-5 fs-7">
                    {t("note2")}
                  </p>
                </div>
                <div className="row justify-content-between align-items-center mb-2 my-md-4 my-lg-5 g-2">
                  <div className="col-6 col-md-4 col-lg-4 col-xl-3">
                    <Link
                      to="/gold-course"
                      type="button"
                      className="btn-explore p-sm-15 bg-secondary text-black d-flex justify-content-between align-items-center gap-3 rounded-2 w-100 mt-4"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width={22}
                        height={14}
                        viewBox="0 0 22 14"
                        fill="none"
                      >
                        <path
                          d="M21 6.99854H1L6 1"
                          stroke="#000C2A"
                          strokeWidth="1.5"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                        <path
                          d="M1 6.99805L6 12.9995"
                          stroke="#000C2A"
                          strokeWidth="1.5"
                          strokeLinecap="round"
                        />
                      </svg>
                      {t("previous")}
                    </Link>
                  </div>
                  <div className="col-6 col-md-4 col-lg-4 col-xl-3">
                    <Link
                      to="/gold-course-quize-1"
                      type="button"
                      className="btn-explore p-sm-15 d-flex justify-content-between align-items-center gap-3 rounded-2 w-100 mt-4"
                    >
                      {t("next")}
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width={22}
                        height={14}
                        viewBox="0 0 22 14"
                        fill="none"
                      >
                        <path
                          d="M1 6.99854H21L16 1"
                          stroke="white"
                          strokeWidth="1.5"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                        <path
                          d="M21 6.99805L16 12.9995"
                          stroke="white"
                          strokeWidth="1.5"
                          strokeLinecap="round"
                        />
                      </svg>
                    </Link>
                  </div>
                </div>
              </div>
              <div className="col-md-12 col-lg-4">
                <CourseSidebar />
              </div>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </>
  );
}

export default FeaturedGoldCourseDetails;
